import React, { useEffect, useState } from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import BuildSection from './components/BuildSection';
import Projects from './components/Projects';
import ExperienceSection from './components/ExperienceSection';
import AIWorkflowSection from './components/AIWorkflowSection';
import ConsultingSection from './components/ConsultingSection';
import TechStackSection from './components/TechStackSection';
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';
import { portfolioContent } from './content/portfolioContent';
import './App.css';

function App() {
  const [language, setLanguage] = useState('pt');
  const content = portfolioContent[language];

  useEffect(() => {
    document.documentElement.lang = language === 'pt' ? 'pt-BR' : 'en';
    document.title =
      language === 'pt'
        ? 'Icaro Felipe de Lanes | Desenvolvedor de Software'
        : 'Icaro Felipe de Lanes | Software Developer';
  }, [language]);

  return (
    <div className="App">
      <Navigation
        content={content.navigation}
        languageLabel={content.meta.languageLabel}
        onToggleLanguage={() =>
          setLanguage((current) => (current === 'pt' ? 'en' : 'pt'))
        }
      />
      <main>
        <Hero content={content.hero} resumeHref={content.meta.resumeHref} />
        <About content={content.about} />
        <BuildSection content={content.services} />
        <Projects content={content.projects} />
        <ExperienceSection content={content.experience} />
        <AIWorkflowSection content={content.aiWorkflow} />
        <ConsultingSection content={content.consulting} />
        <TechStackSection content={content.stack} />
        <Contact
          content={content.contact}
          footer={content.meta.footer}
          legal={content.legal}
        />
      </main>
      <ScrollToTop />
    </div>
  );
}

export default App;
